import React, { useContext, useEffect } from "react";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AuthContext from "../../context/auth/authContext";
import { useParams, useHistory, useLocation } from "react-router-dom";
import TripDetails from "../trips/TripDetails";

const getBackLabel = (from) => {
  if (from === '/my-journeys') return 'Back to My Journeys';
  if (from === '/spots') return 'Back to Local Finds';
  if (from === '/destinations') return 'Back to Discover';
  if (from.startsWith('/destination/')) return 'Back to Trips';
  return 'Back';
};

const TripDetail = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;
  const { trip_id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const from = params.get('from') || '/spots';
  const backLabel = getBackLabel(from);

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Button
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
        onClick={() => history.push(from)}
        sx={{
          textTransform: 'none',
          color: 'text.secondary',
          fontWeight: 500,
          mb: 2,
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        {backLabel}
      </Button>
      <TripDetails trip_id={trip_id} fromPath={from} />
    </Box>
  );
};

export default TripDetail;
